export const SET_TEMPLATEDROPDOWNVALUE_ARD = `SET_TEMPLATEDROPDOWNVALUE_ARD`;
export const SET_ISSENDAPPROVAL_ARD = `SET_ISSENDAPPROVAL_ARD`;
export const SET_ISEDITTEMPLATE_ARD = `SET_ISEDITTEMPLATE_ARD`;
export const SET_ISADDTEMPLATE_ARD = `SET_ISADDTEMPLATE_ARD`;
export const SET_APPROVALREQDATA = `SET_APPROVALREQDATA`
export const SET_REASONINBRIEF_ARD = `SET_REASONINBRIEF_ARD`;
export const SET_URGENTDROPDOWNVALUE_ARD = `SET_URGENTDROPDOWNVALUE_ARD`;
export const SET_SOURCEDOWNVALUE_ARD = `SET_SOURCEDOWNVALUE_ARD`;
export const SET_REASONCODEDROPDOWNVALUE_ARD = `SET_REASONCODEDROPDOWNVALUE_ARD`;

export const setTemplateDropDownValue = (data) => ({
    type: SET_TEMPLATEDROPDOWNVALUE_ARD,
    value: data
});

export const setSourceDropDownValue = (data) => ({
    type: SET_SOURCEDOWNVALUE_ARD,
    value: data
});

export const setReasonCodeDropDownValue = (data) => ({
    type: SET_REASONCODEDROPDOWNVALUE_ARD,
    value: data
});

export const setReasonInBrief = (data) => ({
    type: SET_REASONINBRIEF_ARD,
    value: data
});

export const setUrgentDropDownValue = (data) => ({
    type: SET_URGENTDROPDOWNVALUE_ARD,
    value: data
});

export const setIsSendApproval = (data) => ({
    type: SET_ISSENDAPPROVAL_ARD,
    value: data
});

export const setIsEditTemplate = (data) => ({
    type: SET_ISEDITTEMPLATE_ARD,
    value: data
});

export const setIsAddTemplate = (data) => ({
    type: SET_ISADDTEMPLATE_ARD,
    value: data
});

export const setApprovalReqData = (data) => ({
    type: SET_APPROVALREQDATA,
    value: data
});






